export default __webpack_public_path__ + "static/media/123.48dc218f.jpg";